import { Phone } from "lucide-react";
import { WhatsAppIcon } from "@/components/site/WhatsAppIcon";
import { Reveal } from "@/components/site/Reveal";
import { IMG, PHONE_DISPLAY, PHONE_TEL, waLink, onCall, onWhatsApp } from "@/lib/site";

export const ConversionBand = () => {
  return (
    <section className="relative overflow-hidden grain">
      <div className="absolute inset-0">
        <img src={IMG.realNoiteRua} alt="Guincho DG Guinchos em atendimento noturno em Jundiaí" loading="lazy" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-black/80" />
        <div className="absolute inset-0 bg-gradient-to-r from-brand/25 to-transparent" />
      </div>
      <div className="container-x relative z-10 py-20 md:py-28 text-center">
        <Reveal>
          <h2 className="font-display text-4xl md:text-6xl font-black text-white leading-[0.92]">
            Seu veículo parou?<br />
            <span className="text-brand">Fale com a DG Guinchos.</span>
          </h2>
          <p className="mt-5 text-lg text-zinc-300">Atendimento 24 horas em Jundiaí e região.</p>
          <a
            href={`tel:${PHONE_TEL}`}
            onClick={() => onCall("conversion-band")}
            className="mt-6 inline-flex items-center gap-2 font-display text-3xl md:text-4xl font-black text-white hover:text-brand transition-colors"
          >
            <Phone className="h-7 w-7 text-brand" /> {PHONE_DISPLAY}
          </a>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href={`tel:${PHONE_TEL}`}
              data-testid="conversion-call"
              onClick={() => onCall("conversion-band")}
              className="inline-flex items-center justify-center gap-2.5 bg-brand hover:bg-brand-hover text-white font-display font-bold uppercase tracking-wider text-lg px-8 py-4 rounded-sm transition-all active:scale-95"
            >
              <Phone className="h-5 w-5" /> Ligar Agora
            </a>
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="conversion-whatsapp"
              onClick={() => onWhatsApp("conversion-band")}
              className="inline-flex items-center justify-center gap-2.5 bg-wapp hover:bg-wapp-hover text-black font-display font-bold uppercase tracking-wider text-lg px-8 py-4 rounded-sm transition-all active:scale-95"
            >
              <WhatsAppIcon className="h-6 w-6" /> Chamar no WhatsApp
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
